import CityPageTemplate from "../city-template/CityPageTemplate";
import { kenaiConfig } from "./data";

export default function KenaiPage() {
  return <CityPageTemplate config={kenaiConfig} />;
}